import { Box, Container, Grid2, Typography } from "@mui/material";
import { globalStyle } from "../../../../../themes/global.styles";
import { ChooseUsBg } from "../../../../../assets";
import theme from "../../../../../themes/Theme";
import LightBulb from "../../../../../assets/svg/LightBulb";
import Lightning from "../../../../../assets/svg/Lightning";
import Star from "../../../../../assets/svg/Star";

const ChooseUsSection = () => {
  return (
    <Container sx={styles.container}>
      <center>
        <Typography sx={globalStyle.sectionHeading}>
          Why<span>choose us</span>
        </Typography>
      </center>
      <center>
        <Typography sx={globalStyle.sectionSubheading}>
          Reliable Crypto Wallet for a Sustainable Future
        </Typography>
      </center>
      <Grid2
        container
        spacing={2}
        mt={4}
        gap={4}
        sx={styles.chooseUsContainer}
        justifyContent={"center"}
      >
        <Grid2 size={{ xs: 12, md: 3.5 }} sx={styles.cardContainer}>
          <Box p={2}>
            <Box sx={styles.cardGradientIcon}>
              <LightBulb />
            </Box>
            <Typography sx={styles.cardTitleStyle}>Sustainable</Typography>
            <Typography sx={styles.cardDescriptionStyle}>
              Supports long-term carbon reduction goals with every transaction
              made.
            </Typography>
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 3.5 }} sx={styles.cardContainer}>
          <Box px={2} py={4}>
            <Box sx={styles.cardGradientIcon}>
              <Lightning />
            </Box>
            <Typography sx={styles.cardTitleStyle}>Secure</Typography>
            <Typography sx={styles.cardDescriptionStyle}>
              End-to-end encryption and blockchain immutability ensure your
              tokens remain safe and traceable.
            </Typography>
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 3.5 }} sx={styles.cardContainer}>
          <Box p={2}>
            <Box sx={styles.cardGradientIcon}>
              <Star />
            </Box>
            <Typography sx={styles.cardTitleStyle}>Easy</Typography>
            <Typography sx={styles.cardDescriptionStyle}>
              Enjoy a clean, intuitive dashboard designed for both crypto
              beginners and experts alike.
            </Typography>
          </Box>
        </Grid2>
      </Grid2>
    </Container>
  );
};
export default ChooseUsSection;
const styles = {
  container: {
    py: 6,
  },
  chooseUsContainer: {
    background: `url(${ChooseUsBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed",
    borderRadius: "2.5em",
    py: 4,
    px: 2,
  },
  cardContainer: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "2.229em",
  },
  cardGradientIcon: {
    background: `linear-gradient(90deg, ${theme.palette.custom?.gradientLight} 0%, ${theme.palette.custom?.gradientDark} 100%)`,
    width: "5.348rem",
    height: "5.348rem",
    borderRadius: "1.671rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  cardTitleStyle: {
    fontSize: "clamp(1rem, 2.5vw,  1.56rem)",
    color: theme.palette.primary.main,
    fontWeight: 400,
    marginTop: "1em",
  },
  cardDescriptionStyle: {
    fontSize: "clamp(0.6rem, 2vw,  0.78rem)",
    color: theme.palette.text.secondary,
    fontWeight: 400,
    marginTop: "0.5em",
  },
};
